import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToggleService {

  public collapsed = false;
  constructor() { }

  onResize(event) {
    if (window.innerWidth < 800) {
      // this.collapseCollapsers();
    }
  }

  collapseCollapsers() {
    let collapsers = document.querySelectorAll('[auto-collapse]');
    collapsers.forEach(collapser => {
      this.collapse(collapser.id);
    });
  }

  toggleCollapse(elementId: string): boolean {
    let isCollapsed: boolean = false;
    let el = document.querySelector('#' + elementId);
    if (el) {
      if (el.style.width == "") {
        this.collapsed = true;
        this.collapse(elementId);
        isCollapsed = true;
      } else {
        this.collapsed = false;
        this.expand(elementId);
      }
    }
    return isCollapsed;
  }

  collapse(elementId: string) {
    let el = document.querySelector('#' + elementId);
    el.setAttribute('collapsed', "true");
    el.style.width = "0px";
    el.style.maxWidth = "0px";
    el.style.height = "0px";
    el.style.maxHeight = "0px";
  }

  expand(elementId: string) {
    let el = document.querySelector('#' + elementId);
    el.removeAttribute('collapsed');
    el.style.width = null;
    el.style.maxWidth = null;
    el.style.height = null;
    el.style.maxHeight = null;
  }

  getIsCollapsed(elementId: string) {
    let el = document.querySelector('#' + elementId);
    let collapsedAttribute = el.getAttribute('collapsed');
    if (collapsedAttribute && collapsedAttribute == "true") {
      return true;
    } else {
      return false;
    }
  }

  toggleElementAttribute(elementId: string, attrName: string, value1: string, value2: string = null) {
    let el = document.querySelector('#' + elementId);
    let elAttr = 'el.' + attrName;
    let elExec = elAttr + ' = ' + elAttr + ' == value1 ? value2 : value1;';
    eval(elExec);
  }
}
